import { ApiService } from "./api.service";

export default class PayablesAgingSettingsService extends ApiService {
  namespace = "payablesAgingSettings";
  icon = "WrenchWithScrewdriver";
  name = "message";
  favicon = "WrenchWithScrewdriver2";
  window = 290;
  Width = 690;
  DOMAIN = -69;
  singular = this.terminology.invoice.singular;
  plural = this.terminology.invoice.plural;
  vowel = this.terminology.invoice.vowel;
  action = "action";

  constructor() {
    super("payables-aging-settings");
  }
}
